import React from 'react';

import { StoryblokLink } from '../../../interfaces/StoryblokLink.interface';
import { LinkTarget } from '../../../interfaces/types/LinkTarget.type';

export interface StoryblokLinkProviderProps {
  link: StoryblokLink;
  render: (url: string, target: LinkTarget) => React.ReactElement;
}

const StoryblokLinkProvider: React.FC<StoryblokLinkProviderProps> = ({
  link,
  render,
}) => {
  const url: string = link?.cached_url;
  const anchor: string | undefined = link?.anchor;
  const target: LinkTarget = link?.target ? '_blank' : '_self';
  return render(url + `${anchor ? `#${anchor}` : ''}`, target);
};

export default StoryblokLinkProvider;
